/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="../isessionstorage.d.ts" />
/// <reference path="../controllers/screencontrollerbase.ts" />
/// <reference path="../services/apiservice.ts" />
/// <reference path="../services/authenticationservice.ts" />
/// <reference path="../services/UsersService.ts" />
/// <reference path="../iapirequestconfig.ts" />

module App.Common.Controllers {
	'use strict';

	/**
	 * Enumeration used to determine the way in which the PasswordReset screen is displayed and used
	 */
	enum DisplayMode {
		//No password reset token, user not authenticated
		RequestPasswordReset,
		//Found password reset token
		ResetPassword,
		//No password reset token, user authenticated
        ChangePassword,
        //New user created in WPF Security, allow user to set password for first time
        SetInitialPassword
	}

	class ResetPasswordController extends Controllers.ScreenControllerBase {

		private token: any;

		public displayMode = DisplayMode.RequestPasswordReset;
		public modeRequestPasswordReset = DisplayMode.RequestPasswordReset;
		public modeChangePassword = DisplayMode.ChangePassword;
        public modeResetPassword = DisplayMode.ResetPassword;
        public modeSetInitialPassword = DisplayMode.SetInitialPassword;
		public submitButtonLabel = 'Submit';
		public username = '';
		public currentPassword = '';
		public newPassword = '';
		public confirmNewPassword = '';

		public static $inject = ['$injector'];

		constructor($injector: angular.auto.IInjectorService) {
			super($injector);

			this.notForWindowsAuthenticationUsers();
			this.title = 'Request a password reset';
			this.warnOnUnsavedChanges = false;
			this.fullWidth = true;

		}

		public beforeInitialize(): angular.IPromise<any> {
			this.displayMode = this.getDisplayMode();
			return this.setAuthenticationRequired(this.displayMode === DisplayMode.ChangePassword);
		}

		public initialize(): angular.IPromise<any> {

			this.token = this.$stateParams['id'];
			this.displayMode = this.getDisplayMode();

			switch (this.displayMode) {
				case DisplayMode.RequestPasswordReset:
					this.title = 'Request a password reset';
					this.submitButtonLabel = 'Request password reset';
					this.authentication.deleteSignInDetails();
					break;
				case DisplayMode.ResetPassword:
					this.title = 'Choose a new password';
					this.submitButtonLabel = 'Change password';
					this.authentication.deleteSignInDetails();
					break;
                case DisplayMode.ChangePassword:
                    this.title = 'Change your password';
                    this.submitButtonLabel = 'Change password';
                    return this.setAuthenticationRequired(true);
                case DisplayMode.SetInitialPassword:
                    this.title = 'Create a new password';
                    this.submitButtonLabel = 'Set password';
                    break;
			}

			return this.$q.resolve();
		}

		public submit(): void {

			this.userMessages.clear();

			switch (this.displayMode) {
				case DisplayMode.RequestPasswordReset:
					this.busyPromise = this.requestPasswordReset();
					break;
				case DisplayMode.ResetPassword:
					this.busyPromise = this.resetPassword();
					break;
                case DisplayMode.ChangePassword:
                    this.busyPromise = this.changePassword();
                    break;
                case DisplayMode.SetInitialPassword:
                    this.busyPromise = this.resetPassword();
                    break;
			}
		}

		private requestPasswordReset(): angular.IPromise<any> {
			return this.api.post({
				url: this.globalSettings.authenticationEndpoints.requestPasswordReset,
				deferUserMessageDisplay: true,
				suppressSuccessMessage: true,
				authenticated: false,
				data: {
					userId: this.username,
					source: 'Web',
					resetUrl: this.globalSettings.baseUrl
					+ this.$state.get('ResetPassword').url.toString()
						.replace(':id', '{token}')
						.replace(':source', '{source}')
				}
			}).then(() => {
				this.$state.go('PasswordResetRequested');
			});
		}

        private resetPassword(): angular.IPromise<any> {
			let currentUser = this.users.getCurrentUser();
			this.username = currentUser.username;
            return this.api.post({
                url: this.globalSettings.authenticationEndpoints.resetPassword,
                deferUserMessageDisplay: true,
                successMessage: `Your password has been ${this.displayMode === DisplayMode.ResetPassword ? 'reset' : 'set'} successfully`,
                authenticated: false,
                data: {
                    token: this.token,
                    newPassword: this.newPassword
                }
            }).then((username: string) => {
				this.userMessages.collectDeferredMessages();
				return this.authentication.signIn(username, this.newPassword).then(() => {
					return this.$state.go('Home');
				});
            });
        }

		private changePassword(): angular.IPromise<any> {
			return this.authentication.passwordIsCorrectForCurrentUser(this.currentPassword).then((passwordIsCorrect: boolean) => {
				if (passwordIsCorrect) {
					return this.api.post({
						url: this.globalSettings.authenticationEndpoints.changePassword,
						deferUserMessageDisplay: true,
						successMessage: 'Your password has been reset successfully',
						authenticated: true,
						data: {
							newPassword: this.newPassword,
							currentPassword: this.currentPassword
						}
					}).then(() => {
						this.$state.go('Home');
					});
				} else {
					this.userMessages
						.addMessage('Your current password is incorrect or your account could not be validated', UserMessageType.Error);
					return this.$q.reject();
				}
			});
		}

		private getDisplayMode(): DisplayMode {
			if (this.$state.current.name === 'RequestPasswordReset') {
				return DisplayMode.RequestPasswordReset;
			} else if (this.$state.current.name === 'ResetPassword') {
				return DisplayMode.ResetPassword;
            } else if (this.$state.current.name === 'ChangePassword') {
                return DisplayMode.ChangePassword;
            } else if (this.$state.current.name === 'SetInitialPassword') {
                return DisplayMode.SetInitialPassword;
			} else {
				return DisplayMode.RequestPasswordReset;
			}
		}
	}

	angular
		.module('app.common.controllers')
		.controller('app.common.controllers.resetPasswordController', ResetPasswordController);

}